<template>
  <div class="flex flex-col w-full">
    <div class="bg-neutral-secondary rounded-md px-4 py-3 mb-2">
      <div class="grid grid-flow-row grid-cols-3">
        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press pb-3 self-center col-span-1"
        >
          {{ t('common.amount') }}
        </NText>

        <div class="flex justify-end items-center pb-3 col-span-2">
          <NumberFormatter #="{ number }" :value="item.amount">
            <NText variant="caption1" weight="medium">
              {{ number }}
              <NText
                variant="caption1"
                class="text-neutral-secondary text-left align-middle"
              >
                {{ t('misc.rial') }}
              </NText>
            </NText>
          </NumberFormatter>
        </div>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press pb-3 self-center col-span-1"
        >
          {{ t('common.date') }} {{ t('common.submit_request') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press pb-3 col-span-2"
        >
          {{ d(item.entryDate, 'shortTime') }} ,
          {{ d(item.entryDate, 'shortDate') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press border-b border-neutral-secondary pb-3 self-center col-span-1"
        >
          {{ t('common.requestStatus') }}
        </NText>

        <NText
          v-if="item.isVerified"
          weight="medium"
          variant="caption1"
          class="flex justify-end items-center border-b border-neutral-secondary pb-3 col-span-2"
        >
          {{ t('deposit.status_done') }}
        </NText>

        <NText
          v-else
          :key="item.isVerified"
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-critical-primary border-b border-neutral-secondary pb-3 col-span-2"
        >
          {{ t('deposit.status_rejected') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press py-3 self-center col-span-1"
        >
          {{ t('deposit.paymentGatewayMethod') }}
        </NText>

        <div
          class="flex justify-end items-center text-neutral-secondary-press py-3 col-span-2"
        >
          <NText variant="caption1" weight="medium">
            {{ item.bankTitle }}
          </NText>
        </div>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press self-center col-span-1"
        >
          {{ t('payment.transaction_number') }} {{ t('deposit.bank') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press col-span-2"
        >
          {{ item.resNum }}
        </NText>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { EPayment } from '@libs/api-reference';

import NumberFormatter from '@/components/Number.vue';

type DepositHistoryItem = {
  item: EPayment;
};

defineProps<DepositHistoryItem>();

const { t, d } = useI18n();
</script>
